import { createContext, ReactNode, useContext } from "react";

interface FriendlyCaptchaContextValue {
  enabled: boolean;
  solution: string | null;
}

const FriendlyCaptchaContext = createContext<FriendlyCaptchaContextValue>({
  enabled: false,
  solution: null,
});

interface FriendlyCaptchaProviderProps {
  children: ReactNode;
  enabled: boolean;
  solution?: string;
}

export function FriendlyCaptchaProvider({
  children,
  enabled,
  solution,
}: FriendlyCaptchaProviderProps) {
  const normalizedSolution = solution?.trim() || null;

  return (
    <FriendlyCaptchaContext.Provider
      value={{
        enabled,
        solution: normalizedSolution,
      }}
    >
      {children}
    </FriendlyCaptchaContext.Provider>
  );
}

export function useFriendlyCaptcha(): FriendlyCaptchaContextValue {
  return useContext(FriendlyCaptchaContext);
}